import React, { useState, useEffect } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { DataTable } from "../../../components/tables";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import moment from "moment";
import { courses } from "../../../config";
import { RegisterDataGridCols } from "./data-grid-cols";
import Select from "react-select";

const UploadList = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [registersData, setRegistersData] = useState([]);
  const [filteredRegisters, setFilteredRegisters] = useState([]);
  const [selectCourse, setSelectCourse] = useState("");
  const [date, setDate] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [bdiUserData, setBdiUserData] = useState([]);
  const [formData, setFormData] = useState<any>({
    bdiUserName: "",
  });

  const pathName = window.location.pathname;

  const handleCancel = () => {
    setName("");
    setSelectCourse("");
    setDate("");
    setPhone("");
  
    // reset filtered data back to original list
    setFilteredRegisters(registersData);
  
    // reset selected rows & form data
    setSelectedRows([]);
    setFormData({
      bdiUserName: "",
    });
  };
  

  const handleSearch = () => {
    const trimmedName = name.trim().toLowerCase();
    const trimmedPhone = phone.trim();
    const trimmedDate = date.trim();

    const filteredData = registersData.filter((student: any) => {
      const nameMatch = (student.name || "")
        .toLowerCase()
        .includes(trimmedName);

      const phoneMatch = trimmedPhone
        ? (student.contactNo || "").includes(trimmedPhone)
        : true;

      const dateMatch = trimmedDate
        ? moment(student.createdAt, "DD MMM YYYY, hh:mm A").format(
            "YYYY-MM-DD"
          ) === trimmedDate
        : true;

      return nameMatch && phoneMatch && dateMatch;
    });

    setFilteredRegisters(filteredData);
  };

  useEffect(() => {
    getRegisters();
    getBDIUsers();
  }, []);

  const getBDIUsers = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getBDIUsers(data).then((res: any) => {
      if (res.status === "Success") {
        setBdiUserData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };
  const getRegisters = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
      prospect:false
    };

    AdminService.allUploadList(data).then((res: any) => {
      if (res.status === "Success") {
        if (res.data) {
          const formattedData = res.data.map((item: any) => {
            return {
              ...item,
              createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
            };
          });
          setRegistersData(formattedData);
          setFilteredRegisters(formattedData);
        }
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteAmbassadorInfo = (userId: string) => {
    const payload = {
      uId: userId,
    };
    AdminService.deleteUploadList(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getRegisters();
      } else {
        toast.error(res.message);
      }
    });
  };

  const bOptions = bdiUserData?.map((type: any) => ({
    value: type._id,
    label: type.lastName + " " + type.firstName,
  }));

  const exportData = () => {
    if (pathName === "/manager/uploadList") {
      navigate("/manager/createUpload");
    } else {
      navigate("/admin/createUpload");
    }
  };

  const handleSelectChange = (selectedOption: any, { name }: any) => {
    setFormData({ ...formData, [name]: selectedOption.value });
  };

  const handleAssign = () => {
    const payload = {
      bdiUserId: formData.bdiUserName,
      uploadIds: selectedRows,
    };
    AdminService.assignBdiToUploads(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getRegisters();
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            {/* <div className="col-md-2 mt-3"> */}
            <div className="text-end">
              <button className="btn btn-success" onClick={exportData}>
                Upload
              </button>
            </div>
            {/* </div> */}
            <div className="row">
              <div className="col-md-12 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <b>Students Data</b>
                </label>
                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e: any) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the User Name"
                  />
                  <input
                    type="phone"
                    name="Phone"
                    onChange={(e: any) => setPhone(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={phone}
                    placeholder="Enter the Phone"
                  />
                  <input
                    type="date"
                    name="Date"
                    onChange={(e: any) => setDate(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={date}
                  />
                  {selectedRows?.length > 0 && (
                    <Select
                      options={bOptions}
                      name="bdiUserName"
                      placeholder="Select BDI UserName"
                      className="form-control mt-1 me-2"
                      onChange={handleSelectChange}
                    />
                  )}

                  {selectedRows?.length > 0 && (
                    <button
                      className="btn btn-danger rounded me-3 px-4 py-1"
                      onClick={() => handleAssign()}
                    >
                      Assign BDI
                    </button>
                  )}

                  <button
                    className="btn btn-primary rounded px-4 py-1"
                    onClick={() => handleSearch()}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-5">
              <DataTable
                tableData={filteredRegisters}
                TableCols={RegisterDataGridCols}
                deleteAmbassadorInfo={deleteAmbassadorInfo}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadList;
